module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('video', {
    staticClass: "audioControls",
    attrs: {
      "controls": "controls",
      "preload": "none"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.src,
      "type": "video/mp4"
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cbe7553","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/archives/VideoPlayer.vue
// module id = 451
// module chunks = 1